import { render, staticRenderFns } from "./adminLogin.vue?vue&type=template&id=0d2996b9&scoped=true&"
import script from "./adminLogin.vue?vue&type=script&lang=js&"
export * from "./adminLogin.vue?vue&type=script&lang=js&"
import style0 from "./adminLogin.vue?vue&type=style&index=0&id=0d2996b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2996b9",
  null
  
)

export default component.exports